function gotop() {
    $('html, body').animate({ scrollTop: 0 }, "slow");
}


$('.button_gotop').click(function(e) {
    e.preventDefault();
    
    gotop();
});